var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendaryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.667 1.75716H13.3337C13.5105 1.75716 13.68 1.8274 13.8051 1.95242C13.9301 2.07745 14.0003 2.24702 14.0003 2.42383V13.0905C14.0003 13.2673 13.9301 13.4369 13.8051 13.5619C13.68 13.6869 13.5105 13.7572 13.3337 13.7572H1.33366C1.15685 13.7572 0.987279 13.6869 0.862254 13.5619C0.73723 13.4369 0.666992 13.2673 0.666992 13.0905V2.42383C0.666992 2.24702 0.73723 2.07745 0.862254 1.95242C0.987279 1.8274 1.15685 1.75716 1.33366 1.75716H4.00033V0.423828H5.33366V1.75716H9.33366V0.423828H10.667V1.75716ZM2.00033 5.75716V12.4238H12.667V5.75716H2.00033ZM3.33366 8.42383H6.66699V11.0905H3.33366V8.42383Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaryIcon);
export default __webpack_public_path__ + "static/media/calendaryIcon.4ef9ff2c4c94c29e76fea5e7a07ae370.svg";
export { ForwardRef as ReactComponent };